import { Environment } from 'entities/common'
import { environment } from './environment'

export enum Features {
  amtToggle = 'amtToggle',
  vespaSettings = 'vespaSettings',
  conversions = 'conversions',
  currencyConversions = 'currencyConversions',
}

export type FeaturesConfig = { [key in Features]?: boolean }

const configs: { [index in Environment]: FeaturesConfig } = {
  [Environment.local]: {
    amtToggle: true,
    vespaSettings: true,
    conversions: true,
    currencyConversions: true,
  },
  [Environment.dev]: {
    amtToggle: true,
    vespaSettings: true,
    conversions: true,
    currencyConversions: true,
  },
  [Environment.test]: {
    amtToggle: true,
    vespaSettings: true,
    conversions: true,
    currencyConversions: true,
  },
  [Environment.sit]: {
    amtToggle: true,
    vespaSettings: true,
    conversions: true,
    currencyConversions: true,
  },
  [Environment.uat]: {
    amtToggle: true,
    vespaSettings: true,
    conversions: true,
    currencyConversions: true,
  },
  [Environment.prod]: {
    amtToggle: true,
    vespaSettings: true,
    conversions: true,
    currencyConversions: true,
  },
}

export default configs[environment]
